module.exports = __webpack_public_path__ + "static/media/ic_type_hearing_set.d420783a.svg";